module.exports = __webpack_public_path__ + "img/icon_black_ticket.87eba5e5.svg";